import { CashIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";
import { useNavigate } from "react-router-dom";

interface Props {
  amount: string;
}
export const Cashback = ({ amount }: Props) => {
  const navigate = useNavigate();
  if (Number(amount).toFixed(2) === "0.00") return null;
  return (
    <div className="rounded-[12px] text-text_primary flex w-full items-center justify-between px-4 py-[6px] bg-success_color/10">
      <div className="flex flex-wrap gap-2 items-center">
        <div className="text-xl font-bold">{`+$${Number(amount).toFixed(
          2,
        )}`}</div>
        <CashIcon className="w-4 h-4" />
        <div className="text-xs">Cash due to lower network fees</div>
      </div>
      <div
        className="text-xs text-medium text-success_color whitespace-nowrap cursor-pointer"
        onClick={() => navigate(RoutePath.Wallet)}
      >{`Your wallet >`}</div>
    </div>
  );
};
